import React, { useEffect, useState } from "react";
import PageHeader from "../components/PageHeader";
import { Button } from "@/components/ui/button";
import { MapPin, Clock, Briefcase } from "lucide-react";
import axios from "axios";
import { Loader2 } from "lucide-react";

const Careers = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchJobs = async () => {
        try {
            const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
            const response = await axios.get(`${BACKEND_URL}/api/jobs`);
            setJobs(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };
    fetchJobs();
  }, []);

  return (
    <div className="bg-dreibach-black min-h-screen pb-24">
      <PageHeader 
        title="Careers at Dreibach" 
        subtitle="Join the team building the future of logistics and brand management."
        image="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=2000"
      />

      <div className="container mx-auto px-6 py-24">
         <div className="max-w-4xl mx-auto">
            <h2 className="heading-md text-white mb-12 border-b border-white/10 pb-6">Current Openings</h2>
            
            {loading ? (
                <div className="flex justify-center py-12">
                    <Loader2 className="w-8 h-8 text-dreibach-teal animate-spin" />
                </div>
            ) : jobs.length === 0 ? (
                <div className="text-center py-12 bg-dreibach-card border border-white/10">
                    <p className="text-gray-400 text-lg">No positions currently available. Please check back later.</p>
                </div>
            ) : (
                <div className="space-y-6">
                    {jobs.map(job => (
                        <div key={job.id} className="bg-dreibach-card border border-white/10 p-8 hover:border-dreibach-teal/50 transition-colors group">
                            <div className="flex flex-col md:flex-row justify-between md:items-start gap-6">
                                <div>
                                    <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-dreibach-teal transition-colors">{job.title}</h3>
                                    <div className="flex flex-wrap gap-4 text-sm text-gray-400 mb-6">
                                        <span className="flex items-center gap-1"><Briefcase size={14} /> {job.department}</span>
                                        <span className="flex items-center gap-1"><MapPin size={14} /> {job.location}</span>
                                        <span className="flex items-center gap-1"><Clock size={14} /> {job.type}</span>
                                    </div>
                                    <p className="text-gray-300 leading-relaxed whitespace-pre-wrap">{job.description}</p>
                                </div>
                                <Button className="bg-white text-black hover:bg-dreibach-teal hover:text-white uppercase font-bold tracking-wider rounded-none shrink-0" onClick={() => window.location.href = `mailto:careers@dreibachltd.com?subject=Application: ${job.title}`}>
                                    Apply Now
                                </Button>
                            </div>
                        </div>
                    ))}
                </div>
            )}
         </div>
      </div>
    </div>
  );
};

export default Careers;
